exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-bfc81f5e].yxt-rate__item{margin-right:4px}.comment-title-content-old[data-v-bfc81f5e]{display:flex;align-items:center}\n", ""]);

